import React, { useState, useCallback, RefObject } from 'react';

import { FeatureLabelsContainer } from './FeatureLabelsContainer';
import { OfferLabelsContainer } from './OfferLabelsContainer';
import { useAutoScroll, useAutoScrollSettings, useAutoZoom, useAutoZoomSettings } from './hooks';
import { useApplicationContext } from '../../../../../../shared/utils/applicationContext';
import { Gallery } from '../../../components/Gallery';
import { OfferGalleryPessimizationFlexible } from '../../../components/OfferGalleryPessimizationFlexible';
import { useOfferContext } from '../../../context';
import { isNewbuildingBooked, isNewbuildingBookedFromDeveloper } from '../../../utils/newbuildingBooking';

interface IGalleryContainerProps {
  cardRef: RefObject<HTMLDivElement>;
}

export function GalleryContainer({ cardRef }: IGalleryContainerProps) {
  const { index, media, tracking, offer } = useOfferContext();
  const { config } = useApplicationContext();

  const isBookedFromCian = isNewbuildingBooked(offer, config);
  const isBookedFromDeveloper = isNewbuildingBookedFromDeveloper(offer);

  const [clicked, setClicked] = useState(false);
  const isFlexibleSanctions = config.get<boolean>('Moderation.CustomSanction.NewModerationInfo.Enabled');

  const handleChangeSlide = useCallback(() => {
    if (!clicked) {
      tracking.trackPhotoSlideChanged();
      setClicked(true);
    }
  }, [clicked, tracking.trackPhotoSlideChanged]);

  const isAutoScrollEnabled = useAutoScroll({ cardRef });

  const isAutoZoomEnabled = useAutoZoom({ cardRef });

  const autoScrollSettings = useAutoScrollSettings();

  const autoZoomSettings = useAutoZoomSettings();

  if (isFlexibleSanctions && offer.moderationInfo?.photoStub) {
    return <OfferGalleryPessimizationFlexible photoStub={offer.moderationInfo.photoStub} />;
  }

  return (
    <>
      <Gallery
        media={media}
        deoptimised={index === 0}
        bookedFromCian={isBookedFromCian}
        bookedFromDeveloper={isBookedFromDeveloper}
        onChangeSlide={handleChangeSlide}
        autoScroll={isAutoScrollEnabled}
        autoZoom={isAutoZoomEnabled}
        autoScrollSettings={autoScrollSettings}
        autoZoomSettings={autoZoomSettings}
      />
      <OfferLabelsContainer />
      <FeatureLabelsContainer />
    </>
  );
}
